import { Button } from '@material-ui/core';
import { createStyles, StyledComponentProps, Theme, withStyles } from '@material-ui/core/styles';
import { observer } from 'mobx-react';
import * as React from 'react';
import { ItemDetail } from '../../comps/ItemDetail';
import { adOrderingStore, IAdOrderingItem, IAdOrderingStore } from './AdsOrderingStore';

const _AdOrderingButton = (props: {item: IAdOrderingItem, store: IAdOrderingStore} & StyledComponentProps) : JSX.Element => <>
	<Button
		variant="contained"
		color={'primary'}
		onClick={e => adOrderingStore.onClick(props.item, e)}
		classes={props.classes}>
		{props.item.amountToOrder}× {props.item.name}
	</Button>
	<ItemDetail entity={props.store.dialogItem}
		repo={null as any}
		state={props.store.dialogItemState}
		onDelete={props.store.dialogItemDelete}
		categories={[]}
	/>
</>;

export const AdOrderingButton = withStyles((theme: Theme) => createStyles({
	root: {
		height: theme.spacing(4),
		margin: theme.spacing(1, 2, 2, 2),
	},
	label: {
		maxWidth: '100%',
	},
	text: {

	},
}), {})(observer(_AdOrderingButton));
